import React, { useCallback, useState, createContext, useContext } from 'react';
interface ApplyModalContextValue {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}
const ApplyModalContext = createContext<ApplyModalContextValue | undefined>(undefined);
export function ApplyModalProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  return <ApplyModalContext.Provider value={{
    isOpen,
    open,
    close
  }} data-id="element-51">
      {children}
    </ApplyModalContext.Provider>;
}
export function useApplyModal() {
  const ctx = useContext(ApplyModalContext);
  if (!ctx) {
    throw new Error('useApplyModal must be used within an ApplyModalProvider');
  }
  return ctx;
}